import { render, staticRenderFns } from "./UninvoicedStockCorrectionSearchPage.vue?vue&type=template&id=5b423cb8&scoped=true&"
import script from "./UninvoicedStockCorrectionSearchPage.vue?vue&type=script&lang=ts&"
export * from "./UninvoicedStockCorrectionSearchPage.vue?vue&type=script&lang=ts&"
import style0 from "./UninvoicedStockCorrectionSearchPage.vue?vue&type=style&index=0&id=5b423cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b423cb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VSpacer})
